export default "__VITE_ASSET__DZdrnq4Y__"